import React, { useRef } from 'react';
import { LuPlus } from 'react-icons/lu';

import ListImages from './ListImage';
import {
  BrowseButtonStyled,
  BrowseButtonWrapperStyled,
  FileInput,
  ImagesAndBrowserWrapper,
} from './style';

type Props = {
  id?: string;
  files: File[];
  setFiles: (data: File[]) => void;
  accepts?: string;
  multiple?: boolean;
  isUploading?: boolean;
  showSelectFiles?: boolean;
  showFileBrowser?: boolean;
};

const defaultAccept = '.jpg, .png, .jpeg, .svg';

const BrowseFile = ({
  files,
  setFiles,
  accepts = defaultAccept,
  multiple = false,
  isUploading = false,
  showSelectFiles = true,
  showFileBrowser = true,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const _onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputElement = event.target;
    if (!inputElement || !inputElement.files) return;

    const newFiles: File[] = Array.from(inputElement.files);
    setFiles(Array.isArray(files) ? [...files, ...newFiles] : newFiles);
  };

  const handleFileInputClick = (
    event: React.MouseEvent<HTMLInputElement, MouseEvent>
  ) => {
    const element = event.target as HTMLInputElement;
    element.value = '';
  };

  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  return (
    <ImagesAndBrowserWrapper>
      {showSelectFiles && (
        <ListImages
          files={files}
          setFiles={setFiles}
          noWrapper
          isLoading={isUploading}
        />
      )}

      {showFileBrowser && (
        <BrowseButtonWrapperStyled>
          <BrowseButtonStyled onClick={handleButtonClick}>
            <LuPlus className="icon" />
          </BrowseButtonStyled>
          <FileInput
            ref={inputRef}
            type="file"
            onChange={_onChange}
            onClick={handleFileInputClick}
            accept={accepts}
            multiple={multiple}
          />
        </BrowseButtonWrapperStyled>
      )}
    </ImagesAndBrowserWrapper>
  );
};

export default BrowseFile;
